<template>
  <v-row no-gutters>
    <v-col cols="12" class="pt-6 pb-4">
      <v-tooltip color="#192B46" bottom max-width="250px">
        <template v-slot:activator="{ on }">      
          <div v-on="on">
            <Checkbox 
              v-model="selectedSection.checkoutV2ByProduct" 
              id="checkbox-checkout" 
              label="Checkout por produto"
            /> 
          </div>
        </template>
        Exibição individual do produto no checkout
      </v-tooltip>
    </v-col>

    <v-col cols="12" class="pb-4">
      <v-tooltip color="#192B46" bottom max-width="250px">
        <template v-slot:activator="{ on }">      
          <div v-on="on">
            <Checkbox 
              v-model="selectedSection.showTypeOfTicket" 
              id="checkbox-tipo-ingresso" 
              label="Exibir tipo do ingresso"
            /> 
          </div>
        </template>
        Exibir o tipo do ingresso no título
      </v-tooltip>
    </v-col>

    <v-col cols="12" class="_pt pb-4">
      <TextField v-model="selectedSection.itemsV2Message" label="Mensagem dos Itens" :maxLength="65"/>    
    </v-col>

    <v-col cols="12" class="_pt pb-4">
      <TextField v-model="selectedSection.itemsV2Button" label="Texto botão" :maxLength="20"/>    
    </v-col>  
  </v-row>
</template>

<script>
import Checkbox from '../../../../_v2/ui/Checkbox/Checkbox.vue'
import TextField from '../../../../_v2/ui/TextField.vue'

export default {
  name: 'newLayoutsConfig',
  components: { Checkbox, TextField },
  props: {
    selectedSection: {type: Object, required: true}
  }  
}
</script>
